import React from 'react';
import {Route, Routes} from "react-router-dom";
import {Box} from "@mui/system";
import EventsListScreen from "./eventsList";


const EventsRoutes = () => {
    return (
        <Box sx={{ padding: '8px 12px', maxWidth: '100%' }} flexDirection="column" display={'flex'} flexGrow={1}>
            <Routes>
                <Route
                    path="/"
                    element=<EventsListScreen/>
                />
            </Routes>
        </Box>
    );

}

export default EventsRoutes;